import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
    return (
      <div className="home">
          {/* Hero Section */}
          <section className="hero-section">
              <div className="hero-content">
                  <img src="/klarakNew.png" alt="Klara Krämer" className="profile-image" />
                  <div className="hero-text">
                      <h1 className="hero-title">Klara Krämer</h1>
                      <p className="hero-subtitle">Data Scientist & AI Engineer</p>
                      <p className="hero-description">
                          Transforming data into insights and building innovative solutions
                      </p>
                      <Link to="/projects" className="cta-button">
                          View My Projects
                      </Link>
                  </div>
              </div>
          </section>

          {/* About Section */}
          <section className="about-section">
              <h2 className="section-title">About Me</h2>
              <div className="about-content">
                  <p>Hello! I am a <b>Data Scientist</b> and <b>AI Engineer</b> with experience in deriving data-driven insights and developing innovative solutions.</p>
                  <p>I specialise in data science, business intelligence, and software development, bringing a unique blend of analytical thinking and technical expertise to every project.</p>
              </div>
          </section>

          {/* Programming Skills Section */}
          <section className="skills-section">
              <h2 className="section-title">Technical Skills</h2>
              <div className="skills-grid">
                  <div className="skill-card">
                      <img src="/python.png" alt="Python" className="skill-icon" />
                      <h3>Python</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/java.png" alt="Java" className="skill-icon" />
                      <h3>Java</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/c.png" alt="C" className="skill-icon" />
                      <h3>C</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/r.png" alt="R" className="skill-icon" />
                      <h3>R</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/sql.png" alt="SQL" className="skill-icon" />
                      <h3>SQL</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/javascript.png" alt="JavaScript" className="skill-icon" />
                      <h3>JavaScript</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/matlab.png" alt="Matlab" className="skill-icon" />
                      <h3>Matlab</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/html.png" alt="HTML" className="skill-icon" />
                      <h3>HTML</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/logo192.png" alt="React" className="skill-icon" />
                      <h3>React</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/dax.png" alt="Microsoft DAX" className="skill-icon" />
                      <h3>DAX</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/kubernetes.png" alt="Kubernetes" className="skill-icon" />
                      <h3>Kubernetes</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/typescript.png" alt="TypeScript" className="skill-icon" />
                      <h3>TypeScript</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/linux.png" alt="Linux" className="skill-icon" />
                      <h3>Linux</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/amazon_s3.png" alt="S3 Data Lakes" className="skill-icon" />
                      <h3>S3 Data Lakes</h3>
                  </div>
                  <div className="skill-card">
                      <img src="/mastra.png" alt="Mastra Agentic AI" className="skill-icon" />
                      <h3>Mastra Agentic AI</h3>
                  </div>
              </div>
          </section>

          {/* Languages Section */}
          <section className="languages-section">
              <h2 className="section-title">Linguistic Proficiencies</h2>
              <div className="languages-grid">
                  <div className="language-card">
                      <img src="/germanFlag.png" alt="German flag" className="flag-icon" />
                      <h3>German</h3>
                      <p className="proficiency-level">Native</p>
                  </div>
                  <div className="language-card">
                      <img src="/britishFlag.png" alt="British flag" className="flag-icon" />
                      <h3>English</h3>
                      <p className="proficiency-level">Native</p>
                  </div>
                  <div className="language-card">
                      <img src="/frenchFlag.png" alt="French flag" className="flag-icon" />
                      <h3>French</h3>
                      <p className="proficiency-level">Limited Working</p>
                  </div>
                  <div className="language-card">
                      <img src="/dutchFlag.png" alt="Dutch flag" className="flag-icon" />
                      <h3>Dutch</h3>
                      <p className="proficiency-level">Limited Working</p>
                  </div>
              </div>
          </section>

          {/* Other Skills Section */}
          <section className="other-skills-section">
              <h2 className="section-title">Additional Expertise</h2>
              <div className="expertise-grid">
                  <div className="expertise-card">
                      <div className="expertise-icon">📊</div>
                      <h3>Analytical Skills</h3>
                      <p>Wide-ranging and adaptable analytical capabilities</p>
                  </div>
                  <div className="expertise-card">
                      <div className="expertise-icon">💼</div>
                      <h3>Microsoft Office & Power BI</h3>
                      <p>Excellence in Microsoft Office suite with extensive Power BI expertise</p>
                  </div>
                  <div className="expertise-card">
                      <div className="expertise-icon">👥</div>
                      <h3>Leadership & Organization</h3>
                      <p>Experience in leading teams with outstanding organisational skills</p>
                  </div>
                  <div className="expertise-card">
                      <div className="expertise-icon">💪</div>
                      <h3>Professional Qualities</h3>
                      <p>Resilience, reliability, and commitment to excellence</p>
                  </div>
              </div>
          </section>
      </div>
    );
  }
  
  export default Home;